import React, { useEffect, useState } from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { IoRepeat } from "react-icons/io5";
import { useParams } from "react-router-dom";

import CardWorkoutExercise from "./CardWorkoutExercise";
import CardRest from "./CardRest";

export default function WorkoutContent({ workout, onRestClicked, isRestRunning }) {
  const { idPlanDay, idWorkout, idSuperserie, idExercise } = useParams();
  const [completed, setCompleted] = useState([]);

  const getNCompleted = (idSuperserie, idExercise) => {
    return completed.filter((item) => {
      return item == `${idPlanDay}-${idWorkout}-${idSuperserie}-${idExercise}`
    }).length;
  }

  const getNToComplete = (idSuperserie) => {
    return workout.superseries[idSuperserie].repetitions;
  }

  const onCompletedClicked = (idSuperserie, idExercise) => {
    // Vibrate if supported
    if (navigator.vibrate) {
      navigator.vibrate(200);
    }
    // Find the index of the exercise in the list of completed exercises.
    const nCompleted = getNCompleted(idSuperserie, idExercise);
    const toComplete = getNToComplete(idSuperserie);

    const isCompleted = nCompleted == toComplete;
    let newCompleted = completed ? completed : [];
    // If the exercise is already completed, remove it from the list of completed exercises.
    if (isCompleted) {
      newCompleted = completed.filter((item) => {
        return item !== `${idPlanDay}-${idWorkout}-${idSuperserie}-${idExercise}`
      })
    } else {
      // If the exercise is not completed, add it to the list of completed exercises.
      newCompleted = [...completed, `${idPlanDay}-${idWorkout}-${idSuperserie}-${idExercise}`];
    }

    // Store the updated list of completed exercises.
    localStorage.setItem("completedExercises", newCompleted.join(","));
    setCompleted(newCompleted);
  }

  const onPlayClicked = (idSuperserie, idExercise) => {
    console.log(idSuperserie, idExercise);
  }

  useEffect(() => {
    window.scrollTo(0, 0);

    // Load the list of completed exercises from local storage.
    const savedCompleted = localStorage.getItem("completedExercises");
    if (savedCompleted) {
      setCompleted(savedCompleted.split(","));
    }
  }, [idWorkout, idSuperserie, idExercise, setCompleted]);
  return (
    <div>
      {workout.superseries.map((superserie, idxSuperserie) => {
        return (
          <div key={superserie.id} className="mb-4">
            <Row>
              <Col xs={7}>
                <p className="mb-1" style={{ fontSize: 18 }}>{superserie.name}</p>
              </Col>
              <Col xs={5} className="text-end align-self-end">
                <p className="cardDescription mb-1">
                  <IoRepeat size={18} style={{ marginBottom: 2, marginRight: 4 }} />
                  Serie:{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {superserie.repetitions}
                  </span>{" "}
                </p>
              </Col>
            </Row>
            {superserie.exercises.map((exercise, idxExercise) => (
              <div key={idxExercise}>
                <CardWorkoutExercise
                  exercise={exercise}
                  idxExercise={idxExercise}
                  idxSuperserie={idxSuperserie}
                  toDetails={`/workout/${idPlanDay}/${idWorkout}/${idxSuperserie}/${idxExercise}/ExerciseDetails/`}
                  to={`/workout/${idPlanDay}/${idWorkout}/${idxSuperserie}/${idxExercise}/Content/`}
                  onCompleted={onCompletedClicked}
                  onPlay={onPlayClicked}
                  nCompleted={getNCompleted(idxSuperserie, idxExercise)}
                  nTotToComplete={getNToComplete(idxSuperserie)}
                />
              </div>
            ))}
            {superserie.rest > 0 && (
              <CardRest rest={superserie.rest} onPlayClicked={onRestClicked} active={!isRestRunning} />
            )}
          </div>
        )
      })}
    </div>
  );
}
